// Messages métier (identique dans teqa_store et teqa_confirmation — garder
// les deux fichiers alignés). Traduit les "code" renvoyés par les services
// marketplace / integration / delivery en phrases claires pour l'utilisateur.

const CONFLICT_REASONS = {
  SOURCE_ALREADY_COVERED: "cette boutique est déjà confiée entièrement à un autre agent ou agence",
  SOURCE_HAS_PRODUCT_ASSIGNMENTS: "des produits de cette boutique sont déjà confiés à un autre agent ou agence",
  SOURCE_ALREADY_ASSIGNED_COMPLETELY: "cette boutique est déjà confiée entièrement à un autre agent ou agence",
  PRODUCT_ALREADY_ASSIGNED: "ce produit est déjà confié à un autre agent ou agence",
};

const EXACT = {
  // affectations / collaborations
  ASSIGNMENT_CONFLICT:
    "Affectation impossible : ces commandes sont déjà gérées par un autre agent ou une autre agence de confirmation.",
  ORDER_ALREADY_ASSIGNED:
    "Cette commande est déjà affectée à un autre agent ou agence. Utilisez « Déplacer » pour la réaffecter.",
  ORDER_COVERED_BY_COLLABORATION:
    "Cette commande est déjà traitée automatiquement par un autre agent ou agence (boutique ou produit affecté).",
  // livraison
  NO_CONNECTION: "Aucun compte de livraison connecté pour cette agence. Connectez-le dans Livraison > Agences.",
  CONNECTION_NOT_FOUND: "Ce compte de livraison n'existe plus ou a été désactivé.",
  INCOMPLETE_CONNECTION: "Les identifiants de ce compte de livraison sont incomplets.",
  AGENCY_NOT_CONFIGURED: "Cette agence de livraison n'est pas encore activée sur la plateforme.",
  AGENCY_DISABLED: "Cette agence de livraison est désactivée sur la plateforme.",
  NOT_SUPPORTED: "Cette action n'est pas proposée par cette agence de livraison.",
  IN_PROGRESS: "Envoi déjà en cours pour cette commande. Patientez quelques secondes.",
  UNCONFIRMED:
    "L'agence a peut-être déjà créé ce colis. Vérifiez dans votre espace transporteur avant de réessayer.",
  CONFIRMATION_REQUIRED: "Cette action modifie immédiatement le colis : confirmez pour continuer.",
};

const SUFFIX = {
  _AUTH_FAILED: "Identifiants refusés par l'agence de livraison. Vérifiez la clé API du compte connecté.",
  _TIMEOUT: "L'agence de livraison ne répond pas. Réessayez dans un instant.",
  _UNREACHABLE: "Impossible de joindre l'agence de livraison. Réessayez plus tard.",
  _UNAVAILABLE: "L'agence de livraison est temporairement indisponible.",
  _RATE_LIMITED: "Trop de demandes envoyées à l'agence. Patientez une minute.",
  _NOT_FOUND: "Colis ou ressource introuvable chez l'agence de livraison.",
  _INVALID_RESPONSE: "Réponse inattendue de l'agence de livraison. Vérifiez le colis dans votre espace transporteur.",
};

/** Message métier pour une erreur axios, ou null si le code n'est pas connu. */
export function businessErrorMessage(error) {
  const data = error?.response?.data;
  if (!data || typeof data !== "object") return null;
  const code = String(data.code || "").toUpperCase();

  if (code === "ASSIGNMENT_CONFLICT" && Array.isArray(data.conflicts) && data.conflicts.length) {
    const reasons = [...new Set(data.conflicts.map((c) => CONFLICT_REASONS[c.reason]).filter(Boolean))];
    if (reasons.length) return `Affectation impossible : ${reasons.join(" ; ")}.`;
  }
  if (EXACT[code]) {
    // le détail de l'agence (ex. "Ville invalide") est plus précis que le message générique
    return code === "NOT_SUPPORTED" || code === "NO_CONNECTION" ? data.detail || EXACT[code] : EXACT[code];
  }
  const suffix = Object.keys(SUFFIX).find((s) => code.endsWith(s));
  if (suffix) {
    const detail = typeof data.detail === "string" ? data.detail : "";
    return detail && suffix !== "_AUTH_FAILED" ? detail : SUFFIX[suffix];
  }
  if (code.endsWith("_REJECTED") && data.detail) return String(data.detail);
  return null;
}

/** Premier message d'erreur de champ ({"phone": ["..."]}) -> "phone : ...". */
export function fieldErrorMessage(error) {
  const data = error?.response?.data;
  if (!data || typeof data !== "object") return null;
  const entry = Object.entries(data).find(
    ([key, value]) => !["detail", "code", "conflicts"].includes(key) && (Array.isArray(value) || typeof value === "string")
  );
  if (!entry) return null;
  const [field, value] = entry;
  return `${field.replaceAll("_", " ")} : ${Array.isArray(value) ? value.join(" ") : value}`;
}
